<template>
  <div
    class="mr-16 px-4 py-2 font-bold leading-none rounded-br-xl uppercase"
    :class="[background, color, { 'sm:text-sm md:text-lg lg:text-base xl:text-lg': inCarousel, 'text-xs xl:text-lg px-5': !inCarousel }]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  background: string
  color: string
  inCarousel?: boolean
}

defineProps<Props>()
</script>
